import { isAtobAvailable, isBufferAvailable } from "./caniuse";

export const createMarkup = (markup: string): { __html: string } => ({
	__html: addFormatToImages(markup),
})

function addFormatToImages(markup: string): string {
	const regex = /src\s*=\s*"(.+?)"/g
	return markup.replace(regex, `src=$1?format=webp`)
}

export const base64Decode = (baseString: string): string => {
	if (isBufferAvailable())
		return Buffer.from(baseString, 'base64').toString('utf-8');
	else if (isAtobAvailable()) {
		return atob(baseString)
	}
	//Return nothing if base64 string cannot be handled
	return ""
}